<template>
  <div class="Glass">
    <div class="page-title">{{title}}</div>
    <el-tabs ref="tabs" v-model="activeTab" type="card">
      <el-tab-pane :label="$t('title.glass_cost')" name="0">
        <GlassCost v-if="activeTab === '0'" :has_grant_write="has_grant_write"/>
      </el-tab-pane>
      <el-tab-pane :label="$t('title.glass_mapping')" name="1">
        <GlassMapping v-if="activeTab === '1'" :has_grant_write="has_grant_write"/>
      </el-tab-pane>
      <el-tab-pane :label="$t('title.glass_thickness')" name="2">
        <GlassThickness v-if="activeTab === '2'" :has_grant_write="has_grant_write"/>
      </el-tab-pane>
      <el-tab-pane :label="$t('title.glass_color')" name="3">
        <GlassColor v-if="activeTab === '3'" :has_grant_write="has_grant_write"/>
      </el-tab-pane>
      <el-tab-pane :label="$t('title.customer_glass_level')" name="4">
        <CustomerGlassLevel v-if="activeTab === '4'" :has_grant_write="has_grant_write"/>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import GlassCost from "./GlassCost";
import GlassMapping from "./GlassMapping";
import GlassThickness from "./GlassThickness";
import GlassColor from "./GlassColor";
import CustomerGlassLevel from "./CustomerGlassLevel";
import { authority_level } from "@/common/mixins/authority_level";

export default {
  name: "Glass",
  mixins: [authority_level],
  components: {GlassCost, GlassMapping, GlassThickness, GlassColor, CustomerGlassLevel},
  data() {
    return {
      title: this.$t('title.glass'),  
      activeTab: '0',
    }
  },
  computed: {
    has_grant_write() {      
      return this.isWriteLevel('glass');
    },
  },
}
</script>
